//libs
import React, { memo, useState } from 'react';

//styles
import { Container, PriceComponent, Price, IconWrapper, Icon, IOElement } from './styles';

//constants
import { DEFAULT_CURRENCY } from 'shared/constants';

const PRICE_DROP_TEXT = 'Price dropped by ';

const PriceDrop = ({ price }: { price: number }) => {
  const [showAnimation, setShowAnimation] = useState(false);

  if (!price) return null;

  return (
    <Container>
      <PriceComponent>
        {PRICE_DROP_TEXT}
        <Price data-test="price">{DEFAULT_CURRENCY + price}</Price>
        <IOElement onVisible={() => setShowAnimation(true)} once />
        {showAnimation && (
          <IconWrapper>
            <Icon />
          </IconWrapper>
        )}
      </PriceComponent>
    </Container>
  );
};

export default memo(PriceDrop);
